import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/queryClient';
import { TanStackDevtools } from '@tanstack/react-devtools';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';
import { formDevtoolsPlugin } from '@tanstack/react-form-devtools';
import { AppRouterContext } from '@/lib/router.tsx';
import { SidebarManager } from '@/common/components/sidebar-manager/SidebarManager';
import { Toaster } from '@/common/components/ui/sonner';
import { OutdatedBuildDialog } from '@/features/build-version/components/outdated-build-dialog/OutdatedBuildDialog';
import { NotFoundPage } from '@/common/pages/not-found-page/NotFoundPage';

export const Route = createRootRouteWithContext<AppRouterContext>()({
  component: () => (
    <QueryClientProvider client={queryClient}>
      <SidebarManager>
        <Outlet />
      </SidebarManager>
      <Toaster richColors position="bottom-right" />
      <OutdatedBuildDialog />
      <TanStackDevtools
        config={{
          position: 'bottom-left',
        }}
        plugins={[
          {
            name: 'TanStack Query',
            render: <ReactQueryDevtoolsPanel />,
          },
          {
            name: 'TanStack Router',
            render: <TanStackRouterDevtoolsPanel />,
          },
          formDevtoolsPlugin(),
        ]}
      />
    </QueryClientProvider>
  ),
  notFoundComponent: NotFoundPage,
});
